import React, { useEffect, useState, useRef, useCallback } from 'react'
import Layout from '../../Components/Layout'
import SearchForm from '../../Components/Hotel/SearchForm'
import ListCard from '../../Components/Hotel/ListCard'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import hotelService from '../../services/hotelService';
import amenitiesService from '../../services/amenitiesService';
import { FaStar, FaHotel, FaShoppingCart, FaTrash } from "react-icons/fa";
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import staticDataService from '../../services/staticDataService';
import neighborhoodService from '../../services/neighborhoodService';
import popularLocationService from '../../services/popularLocationService';
import config from '../../config';
import Swal from 'sweetalert2';
import GoogleMapsLoader from '../../Components/Autocomplete/GoogleMapsLoader';
import { getPrice } from '../../services/priceUtils';
import axios from 'axios';

export default function List4() {
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const apiKey = config.API_KEY;
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const navigate = useNavigate();
    const { occupancies, start_date, end_date } = location.state || {};
    const [hotelCodes, setHotelCodes] = useState([]);
    const [hotelList, setHotelList] = useState([]);
    const [prices, setPrices] = useState({
        min_price: 0,
        max_price: 7500
    });
    const [rates, setRates] = useState({
        minRate: 0,
        maxRate: 7500
    });
    const [selectedStar, setSelectedStar] = useState(null);
    const [selectedBoards, setSelectedBoards] = useState([]);
    const [selectedAccommodations, setSelectedAccommodations] = useState([]);
    const [selectedChain, setSelectedChain] = useState([]);
    const [selectedNeighborhood, setSelectedNeighborhood] = useState(null);
    const [selectedPopularLocation, setSelectedPopularLocation] = useState(null);
    const [formParams, setFormParams] = useState({
        hotel_code: searchParams.get('hotel_code'),
        locationName: searchParams.get('locationName'),
        checkIn: searchParams.get('checkIn'),
        checkOut: searchParams.get('checkOut'),
        nation: searchParams.get('nation'),
        lat: searchParams.get('lat'),
        lng: searchParams.get('lng'),
        occupanciesStr: searchParams.get('occupancies'),
        accTypes: searchParams.get('accTypes'),
        chains: searchParams.get('chain'),
        rooms: (() => {
            try {
                const occupanciesStr = searchParams.get('occupancies');
                if (occupanciesStr) {
                    // URL decode işlemi
                    const decodedStr = decodeURIComponent(occupanciesStr);
                    const parsed = JSON.parse(decodedStr);

                    // Eğer parsed bir array ise, her bir odayı doğru formata dönüştür
                    if (Array.isArray(parsed)) {
                        return parsed.map((room, index) => ({
                            id: index + 1,
                            adultCounter: room.adults || 2,
                            childCounter: room.children || 0,
                            childrenAges: room.paxes?.filter(pax => pax.type === "CH").map(child => ({
                                type: 'CH',
                                age: child.age || 0
                            })) || []
                        }));
                    }
                }
            } catch (error) {
                console.error('Error parsing occupancies:', error);
            }
            // Fallback default değer
            return [{
                id: 1,
                adultCounter: 2,
                childCounter: 0,
                childrenAges: []
            }];
        })()
    });
    const [initialHotels, setInitialHotels] = useState([]); // İlk endpointten gelen veriler
    const [firstHotel, setFirstHotel] = useState(null); // İlk endpointten gelen veriler
    const [hotelIds, setHotelIds] = useState([]); // Otel ID'leri
    const [mergedHotels, setMergedHotels] = useState([]); // Content bilgileriyle merge edilmiş veriler
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        hasMore: false,
        totalPages: 0
    });
    const [sortOption, setSortOption] = useState({type:'default', column:'default'});

    const [accommodationLess, setAccommodationLess] = useState(true);
    const [chainLess, setChainLess] = useState(true);
    const [neighborhoodLess, setNeighborhoodLess] = useState(true);
    const [popularLocationLess, setPopularLocationLess] = useState(true);
    const [boardsLess, setBoardsLess] = useState(true);
    const [chains, setChains] = useState([]);
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [popularLocations, setPopularLocations] = useState([]);
    const [accommodation, setAccommodation] = useState([]);
    const [boards, setBoards] = useState([]);
    const debounceTimeout = useRef(null);

    const [markers, setMarkers] = useState([]);
    const [dynamicNeighborhoods, setDynamicNeighborhoods] = useState([]);

    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [amenities, setAmenities] = useState([]);
    const [amenitiesLess, setAmenitiesLess] = useState(true);

    const [cartSummary, setCartSummary] = useState({
        totalRooms: 0,
        roomTypes: [],
        items: {},
        quantities: {} // Yeni eklenen alan
    });

    const [roomLimits, setRoomLimits] = useState({});

    // Initialize room limits from guest selection
    useEffect(() => {
        const guestSelection = JSON.parse(localStorage.getItem('guest_selection')) || { rooms: [] };
        const initialLimits = {};
        
        guestSelection.rooms.forEach(room => {
            const key = `${room.adultCounter}adults-${room.childCounter}children`;
            initialLimits[key] = {
                limit: room.roomCounter,
                current: 0,
                disabled: false
            };
        });
        
        setRoomLimits(initialLimits);
    }, []);

    // Update room limits when cart changes
    useEffect(() => {
        const cart = JSON.parse(localStorage.getItem('cart')) || { data: [] };
        const updatedLimits = { ...roomLimits };
        
        // Reset current counts
        Object.keys(updatedLimits).forEach(key => {
            updatedLimits[key].current = 0;
        });
        
        // Count rooms in cart
        cart.data.forEach(item => {
            const key = `${item.adults}adults-${item.children}children`;
            if (updatedLimits[key]) {
                updatedLimits[key].current += 1;
                updatedLimits[key].disabled = updatedLimits[key].current >= updatedLimits[key].limit;
            }
        });
        
        setRoomLimits(updatedLimits);
    }, [cartSummary.totalRooms]);

    // Fetch static data on component mount
    useEffect(() => {
        const fetchStaticData = async () => {
            try {
                const [accomData, boardsData, chainsData, amenitiesData] = await Promise.all([
                    staticDataService.getAccommodationTypes(),
                    staticDataService.getBoards(),
                    staticDataService.getChains(),
                    amenitiesService.getAmenities()
                ]);
                setAccommodation(accomData);
                setBoards(boardsData);
                setChains(chainsData);
                setAmenities(amenitiesData);
            } catch (error) {
                console.error('Error fetching static data:', error);
            }
        };
        const fetchLocationData = async () => {
            if (formParams.lat && formParams.lng) {
                try {
                    // Neighborhood verilerini çek
                    const neighborhoodsData = await neighborhoodService.getNeighborhoods(formParams.lat, formParams.lng);
                    setNeighborhoods(neighborhoodsData);
                    
                    // Dynamic verileri birden fazla kategoride paralel olarak çek
                    const dynamicQueries = [
                        'districts subdistricts neighborhoods',
                        'points_of_interest establishments',
                        'tourist_attraction shopping_mall',
                        'route street_address premise',
                        'locality sublocality administrative_area'
                    ];

                    const dynamicPromises = dynamicQueries.map(query => 
                        neighborhoodService.getRegions({ 
                            type: query, 
                            place: formParams.locationName 
                        }).catch(error => {
                            console.warn(`Failed to fetch ${query}:`, error);
                            return { results: [] };
                        })
                    );

                    const dynamicResults = await Promise.all(dynamicPromises);
                    
                    // Tüm sonuçları birleştir
                    const allResults = dynamicResults.reduce((acc, result) => {
                        if (result && result.results) {
                            acc.push(...result.results);
                        }
                        return acc;
                    }, []);

                    console.log('Enhanced dynamicData: ', { results: allResults });
                    
                    // Popular Location verilerini genişletilmiş kategorilerle çek
                    const popularLocationsData = await popularLocationService.getPopularLocations(formParams.lat, formParams.lng);
                    setPopularLocations(popularLocationsData);
                } catch (error) {
                    console.error('Error fetching location data:', error);
                }
            }
        };
        fetchLocationData();
        fetchStaticData();
    }, []);

    useEffect(() => {
        const fetchLocationData = async () => {
            if (formParams.lat && formParams.lng) {
                try {
                    // Dynamic verileri çek
                    const dynamicData = await neighborhoodService.getRegions({ 
                        type: 'districts subdistricts neighborhoods', 
                        place: formParams.locationName 
                    });

                    // Sonuçları filtrele ve işle
                    if (dynamicData && dynamicData.results) {
                        // Mesafe hesaplama fonksiyonu
                        const calculateDistance = (lat1, lng1, lat2, lng2) => {
                            const toRad = (value) => (value * Math.PI) / 180;
                            const R = 6371; // Dünya yarıçapı (km)
                            const dLat = toRad(lat2 - lat1);
                            const dLng = toRad(lng2 - lng1);
                            const a =
                                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                                Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                                Math.sin(dLng / 2) * Math.sin(dLng / 2);
                            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                            return R * c; // Mesafe (km)
                        };

                        const uniqueNeighborhoods = dynamicData.results.reduce((acc, current) => {
                            // Aynı formatted_address'e sahip öğeleri kontrol et
                            const x = acc.find(item => item.formatted_address === current.formatted_address);
                            if (!x) {
                                // Mahalle adını ilk virgüle kadar olan kısımdan al
                                const addressParts = current.formatted_address.split(',');
                                const mahalleAdi = addressParts[0].trim();

                                // Eğer bu adres parçası daha önce eklenmişse, ekleme
                                const isDuplicate = acc.some(item => {
                                    const itemParts = item.formatted_address.split(',');
                                    return itemParts[0].trim() === addressParts[0].trim();
                                });

                                // Çok kısa adları ve sayıları filtrele
                                if (!isDuplicate && mahalleAdi.length > 2 && !/^\d+$/.test(mahalleAdi)) {
                                    // Mesafe hesapla
                                    const distance = calculateDistance(
                                        parseFloat(formParams.lat),
                                        parseFloat(formParams.lng),
                                        current.geometry?.location?.lat || 0,
                                        current.geometry?.location?.lng || 0
                                    );

                                    acc.push({
                                        formatted_address: current.formatted_address,
                                        geometry: current.geometry,
                                        name: mahalleAdi,
                                        types: current.types,
                                        place_id: current.place_id,
                                        distance: distance
                                    });
                                }
                            }
                            return acc;
                        }, []);

                        // Popülerlik ve tipe göre sırala
                        const sortedNeighborhoods = uniqueNeighborhoods.sort((a, b) => {
                            // Önce neighbourhood tipini öncelik ver
                            const aIsNeighborhood = a.types.includes('neighborhood') || a.types.includes('sublocality');
                            const bIsNeighborhood = b.types.includes('neighborhood') || b.types.includes('sublocality');
                            
                            if (aIsNeighborhood && !bIsNeighborhood) return -1;
                            if (!aIsNeighborhood && bIsNeighborhood) return 1;
                            
                            // Sonrasında mesafeye göre sırala
                            return a.distance - b.distance;
                        });

                        // Yeni mahalleler geldiğinde seçili mahalleyi temizle
                        setSelectedNeighborhood(null);

                        // Tüm neighborhood checkbox'larını false yap
                        const neighborhoodInputs = document.querySelectorAll('input[name="neighborhood"]');
                        neighborhoodInputs.forEach(input => {
                            input.checked = false;
                        });

                        setDynamicNeighborhoods(sortedNeighborhoods);
                    }
                } catch (error) {
                    console.error('Error fetching location data:', error);
                }
            }
        };
        fetchLocationData();
    }, [formParams.lat, formParams.lng, formParams.locationName]);

    const fetchData = async (params = {}) => {
        console.log('🔍 fetchData called with params:', params);
        console.log('📍 Current formParams.lat:', formParams.lat, 'lng:', formParams.lng);
        
        setIsLoading(true);
        setError(null);
        // Önce firstHotel fetch işlemi
        try {
            if (formParams.hotel_code) {
                try {
                    const requestData = {
                        hotelId: parseInt(formParams.hotel_code),
                        sourceMarket: formParams.nation || "DE",
                        checkIn: formParams.checkIn,
                        checkOut: formParams.checkOut,
                        occupancies: formParams.rooms.map(room => ({
                            rooms: 1,
                            adults: room.adultCounter,
                            children: room.childCounter,
                            paxes: room.childrenAges.map(child => ({
                                type: "CH",
                                age: child.age || 0
                            }))
                        })),
                        boardCodes: [],
                        filter: {
                            ...(rates.minRate ? { minRate: rates.minRate } : {}),
                            ...(rates.maxRate ? { maxRate: rates.maxRate } : {}),
                            ...(formParams.star ? { minCategory: formParams.star, maxCategory: formParams.star } : {})
                        },
                        ...(formParams.accTypes ? { accommodations: [formParams.accTypes] } : {}),
                        ...(formParams.chains ? { chains: [formParams.chains] } : {}),
                        ...(selectedAmenities.length > 0 ? { facilities: selectedAmenities } : {})
                    };
        
                    const response = await hotelService.getHotelAvailability(requestData);
                    
                    if (response && response.hotel) {
                        try {
                            const contentResponse = await hotelService.getHotelContent(response.hotel.id);
                            
                            if (contentResponse && contentResponse.code === response.hotel.id) {
                                const mergedData = {
                                    ...response.hotel,
                                    name: contentResponse.name?.content || response.hotel.name,
                                    description: contentResponse.description?.content || '',
                                    address: contentResponse.address?.content || response.hotel.address,
                                    city: contentResponse.city || {
                                        content: response.hotel.city
                                    },
                                    country: contentResponse.country || {
                                        code: '',
                                        isoCode: '',
                                        description: {
                                            content: response.hotel.country
                                        }
                                    },
                                    category: contentResponse.category?.description?.content || '',
                                    accommodationType: contentResponse.accommodationType?.typeMultiDescription?.content || '',
                                    boards: contentResponse.boards || [],
                                    facilities: contentResponse.facilities || [],
                                    image: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    thumbnail: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    web: contentResponse.web || '',
                                    phones: contentResponse.phones || [],
                                    postalCode: contentResponse.postalCode || '',
                                    ranking: contentResponse.ranking || 0,
                                    wildcards: contentResponse.wildcards || []
                                };
                                
                                setFirstHotel(mergedData);
                                console.log('First Merged Hotel Data:', mergedData);
                            }
                        } catch (err) {
                            console.error(`Error fetching content for first hotel:`, err);
                        }
                    }
                } catch (err) {
                    console.error("Error in fetchFirstHotel:", err);
                } 
        }
            const timestamp = new Date().getTime();
            const requestData = {
                geolocation: params.geolocation || {
                    latitude: parseFloat(formParams.lat),
                    longitude: parseFloat(formParams.lng),
                    radius: 10
                },
                page: params.page || 1,
                perPage: 10,
                sourceMarket: formParams.nation || "DE",
                checkIn: formParams.checkIn,
                checkOut: formParams.checkOut,
                occupancies: formParams.rooms.map(room => ({
                    rooms: 1,
                    adults: room.adultCounter,
                    children: room.childCounter,
                    paxes: room.childrenAges.map(child => ({
                        type: "CH",
                        age: child.age || 0
                    }))
                })),
                filter: {
                    ...(formParams.star ? { minCategory: formParams.star, maxCategory: formParams.star } : {}),
                    ...(rates.minRate ? { minRate: rates.minRate } : {}),
                    ...(rates.maxRate ? { maxRate: rates.maxRate } : {})
                },
                ...(formParams.accTypes ? { accommodations: [formParams.accTypes] } : {}),
                ...(formParams.chains ? { chains: [formParams.chains] } : {}),
                ...(selectedAmenities.length > 0 ? { facilities: selectedAmenities } : {}),
                _t: timestamp,
                ...(sortOption.type !== 'default' && {
                    sortType: sortOption.type,
                    sortOrder: sortOption.column
                }),
                ...params
            };

            const response = await hotelService.searchHotels(requestData);

            let currentPage = params.page || 1;
            let retryCount = 0;
            let finalResponse = response;

            // Eğer ilk yanıt boşsa ve retryCount 3'ten küçükse, sonraki sayfaları dene
            while (!finalResponse?.data?.length && retryCount < 3) {
                retryCount++;
                currentPage++;
                
                const retryRequestData = {
                    ...requestData,
                    page: currentPage
                };

                finalResponse = await hotelService.searchHotels(retryRequestData);
            }

            if (finalResponse && finalResponse.data && finalResponse.data.length > 0) {
                const rawHotels = finalResponse.data;
                const ids = rawHotels.map(h => h.id);
                setHotelIds(ids);

                // Otelleri ID bazında detaylarla birleştir
                const mergedHotels = await Promise.all(
                    rawHotels.map(async (hotel) => {

                        try {

                            const contentResponse = await hotelService.getHotelContent(hotel.id);

                            if (contentResponse && String(contentResponse.code) === String(hotel.id)) {
                                const mergedData = {
                                    ...hotel,
                                    name: contentResponse.name?.content || hotel.name,
                                    description: contentResponse.description?.content || '',
                                    address: contentResponse.address?.content || hotel.address,
                                    city: contentResponse.city || {
                                        content: hotel.city
                                    },
                                    country: contentResponse.country || {
                                        code: '',
                                        isoCode: '',
                                        description: {
                                            content: hotel.country
                                        }
                                    },
                                    category: contentResponse.category?.description?.content || '',
                                    accommodationType: contentResponse.accommodationType?.typeMultiDescription?.content || '',
                                    boards: contentResponse.boards || [],
                                    facilities: contentResponse.facilities || [],
                                    image: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    thumbnail: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    web: contentResponse.web || '',
                                    phones: contentResponse.phones || [],
                                    postalCode: contentResponse.postalCode || '',
                                    ranking: contentResponse.ranking || 0,
                                    wildcards: contentResponse.wildcards || []
                                };
                                
                                // Fiyat dönüşümü işlemi
                                if (mergedData.rooms) {
                                    mergedData.rooms.forEach(room => {
                                        if (room.rates) {
                                            room.rates.forEach(rate => {
                                                if (rate.currency && rate.currency !== 'EUR') {
                                                    getPrice(
                                                        rate.net,
                                                        userData.token,
                                                        'EUR',
                                                        rate.taxes,
                                                        mergedData.country?.code,
                                                        rate.currency
                                                    ).then(convertedPrice => {
                                                        rate.net = convertedPrice;
                                                        rate.currency = 'EUR';
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }

                                return mergedData;
                            } else {

                                return hotel;
                            }
                        } catch (err) {

                            return hotel;
                        }
                    })
                );

                console.log("Final merged hotels:", mergedHotels);
                
                if (params.page && params.page > 1) {
                    setInitialHotels(prevHotels => [...prevHotels, ...mergedHotels]);
                } else {
                    setInitialHotels(mergedHotels);
                }
                
                setPagination({
                    currentPage: params.page || 1,
                    hasMore: response.pagination?.hasMore || false,
                    totalPages: response.pagination?.totalPages || 0
                });
            } else {
                console.log('No hotels found in initial response:', response);
                setInitialHotels([]);
                setHotelIds([]);
            }
        } catch (err) {
            console.error("Error in fetchHotels:", err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
        
    };

    useEffect(() => {
        fetchData(
            {
                filter: {
                    ...(selectedStar ? { minCategory: selectedStar, maxCategory: selectedStar } : {}),
                    ...(rates.minRate ? { minRate: rates.minRate } : {}),
                    ...(rates.maxRate ? { maxRate: rates.maxRate } : {}),
                },
                boardCodes: selectedBoards,
                accommodations: selectedAccommodations,
                chains: selectedChain,
                ...(selectedAmenities.length > 0 ? { facilities: selectedAmenities } : {})
            }
        );
    }, [selectedStar, selectedAccommodations, selectedChain, selectedBoards, rates, sortOption, selectedAmenities]);

    useEffect(() => {
        if (initialHotels && initialHotels.length > 0) {
            setMarkers(getMarkers(initialHotels));
        }
    }, [initialHotels]);

    const handleBoardChange = (code) => {
        setSelectedBoards(prev => {
            const newBoards = prev.includes(code) 
                ? prev.filter(item => item !== code)
                : [...prev, code];
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            if (newBoards.length > 0) {
                newParams.set('boards', newBoards.join(','));
            } else {
                newParams.delete('boards');
            }
            setSearchParams(newParams);
            
           /*  fetchData({
                boardCodes: newBoards
            }); */
            
            return newBoards;
        });
    };

    const handleAccomChange = (code) => {
        setSelectedAccommodations(prev => {
            const newAccommodations = prev.includes(code) 
                ? prev.filter(item => item !== code)
                : [...prev, code];
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            if (newAccommodations.length > 0) {
                newParams.set('accTypes', newAccommodations.join(','));
            } else {
                newParams.delete('accTypes');
            }
            setSearchParams(newParams);
            
            /*  fetchData({
                accommodations: newAccommodations
            }); */
            
            return newAccommodations;
        });
    };

    const handleChainChange = (id) => {
        setSelectedChain(prev => {
            const newChain = prev.includes(id) 
                ? prev.filter(item => item !== id)
                : [...prev, id];
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            if(newChain.length > 0) {
                newParams.set('chain', newChain.join(','));
            } else {
                newParams.delete('chain');
            }
            setSearchParams(newParams);
            
            // Yeni filtrelerle otel araması yap
            /*  fetchData({
                chains: newChain
            }); */
            
            return newChain;
        });
    };

    const handleStarClick = (star) => {
        const newStar = star === selectedStar ? null : star;
        setSelectedStar(newStar);
        
        // URL parametrelerini güncelle
        const newParams = new URLSearchParams(searchParams);
        if (newStar) {
            newParams.set('star', newStar);
        } else {
            newParams.delete('star');
        }
        setSearchParams(newParams);
        
        // Yeni filtrelerle otel araması yap
        /*  fetchData({
            filter: {
                ...(newStar ? {
                    minCategory: newStar,
                    maxCategory: newStar
                } : {})
            }
        }); */

    };

    const handleNeighborhoodChange = (item) => {
        if (item) {
            // Eğer seçilen mahalle zaten seçili olan mahalle ise, seçimi kaldır
            if (selectedNeighborhood?.formatted_address === item.formatted_address) {
                // URL parametrelerini temizle
                const newParams = new URLSearchParams(searchParams);
                newParams.delete('lat');
                newParams.delete('lng');
                newParams.delete('locationName');
                setSearchParams(newParams);

                // Form parametrelerini temizle
                setFormParams(prev => ({
                    ...prev,
                    lat: null,
                    lng: null,
                    locationName: null
                }));

                // Seçili mahalleyi temizle
                setSelectedNeighborhood(null);

                // Otelleri orijinal koordinatlarla fetch et
                fetchData();
                return;
            }

            // Seçilen mahallenin koordinatlarını al
            const { lat, lng } = item.geometry.location;
            
            // Mahalle adını formatted_address'ten al
            const addressParts = item.formatted_address.split(',');
            const mahalleAdi = addressParts[0].trim();
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            newParams.set('lat', lat);
            newParams.set('lng', lng);
            newParams.set('locationName', item.formatted_address);
            setSearchParams(newParams);

            // Form parametrelerini güncelle
            setFormParams(prev => ({
                ...prev,
                lat: lat.toString(),
                lng: lng.toString(),
                locationName: item.formatted_address
            }));

            // Seçili mahalleyi güncelle
            setSelectedNeighborhood(item);

            // Popular Locations seçimini sıfırla
            const popularLocationInputs = document.querySelectorAll('input[name="popularLocation"]');
            popularLocationInputs.forEach(input => {
                input.checked = false;
            });

            // Otelleri yeni koordinatlarla fetch et
            fetchData({
                geolocation: {
                    latitude: lat,
                    longitude: lng,
                    radius: 3,
                    unit: "km"
                }
            });
        }
    };

    const handlePopularLocationChange = (name) => {
        console.log('handlePopularLocationChange called with:', name);
        console.log('selectedPopularLocation:', selectedPopularLocation);
        
        // Eğer seçili olan location'a tekrar tıklandıysa
        if (selectedPopularLocation?.name === name) {
            console.log('Deselecting location:', name);
            // Seçimi kaldır
            setSelectedPopularLocation(null);
            
            // Checkbox'ı unchecked yap
            const popularLocationInputs = document.querySelectorAll('input[name="popularLocation"]');
            popularLocationInputs.forEach(input => {
                if (input.value === name) {
                    input.checked = false;
                }
            });
            
            // URL parametrelerini temizle
            const newParams = new URLSearchParams(searchParams);
            newParams.delete('lat');
            newParams.delete('lng');
            newParams.delete('locationName');
            setSearchParams(newParams);

            // Form parametrelerini temizle
            setFormParams(prev => ({
                ...prev,
                lat: null,
                lng: null,
                locationName: null
            }));

            // Otelleri orijinal koordinatlarla fetch et
            fetchData();
            return;
        }

        const selected = popularLocations.find(item => item.name === name);
        if (selected) {
            console.log('Selecting new location:', name);
            // Seçilen lokasyonun koordinatlarını al
            const { lat, lng } = selected.geometry.location;
            
            // Lokasyon adını ve adres bilgisini al
            const formattedAddress = selected.formatted_address;
            
            // localStorage'daki place_name'i güncelle
            localStorage.setItem('place_name', formattedAddress);
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            newParams.set('lat', lat);
            newParams.set('lng', lng);
            newParams.set('locationName', formattedAddress);
            setSearchParams(newParams);

            // Form parametrelerini güncelle
            setFormParams(prev => ({
                ...prev,
                lat: lat.toString(),
                lng: lng.toString(),
                locationName: formattedAddress
            }));

            // Seçili popular location'ı güncelle
            setSelectedPopularLocation(selected);

            // Neighborhood seçimini sıfırla
            const neighborhoodInputs = document.querySelectorAll('input[name="neighborhood"]');
            neighborhoodInputs.forEach(input => {
                input.checked = false;
            });

            // Otelleri yeni koordinatlarla fetch et
            fetchData({
                geolocation: {
                    latitude: lat,
                    longitude: lng,
                    radius: 3,
                    unit: "km"
                }
            });
        }
    };

    const handleRangeChange = (values) => {
        setPrices({
            min_price: values[0],
            max_price: values[1]
        });
    };

    // Debounced price update
    const handleDragEnd = useCallback(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }
        
        debounceTimeout.current = setTimeout(() => {
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            newParams.set('minPrice', prices.min_price);
            newParams.set('maxPrice', prices.max_price);
            setSearchParams(newParams);
            setRates({
                minRate: prices.min_price,
                maxRate: prices.max_price
            });

            /* fetchData({
                filter: {
                    minRate: prices.min_price,
                    maxRate: prices.max_price
                }
            }); */
        }, 500);
    }, [prices, searchParams, setSearchParams]);



    const handleViewDetails = async (hotel) => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const occupanciesStr = urlParams.get('occupancies');

            const params = new URLSearchParams();
            params.set('code', hotel.id || hotel.code); // id veya code kullan
            params.set('slug', hotel.slug || hotel.name?.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''));
            params.set('checkIn', urlParams.get('checkIn'));
            params.set('checkOut', urlParams.get('checkOut'));
            params.set('occupancies', occupanciesStr);
            params.set('nationality', urlParams.get('nation'));

            navigate(`/hotel-detail/${params.get('code')}/${params.get('slug')}?${params.toString()}`);
        } catch (error) {
            console.error('Error in handleViewDetails:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to navigate to hotel details',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
    };

    const handleBookSubmit = async (offerKey) => {
        try {
            // Kullanıcı kontrolü
            if (!userData?.token) {
                Swal.fire({
                    title: "Lütfen önce giriş yapın!",
                    icon: "error",
                    draggable: true,
                });
                return;
            }

            // offerKey kontrolü
            if (!offerKey) {
                Swal.fire({
                    title: "Hata!",
                    text: "Rezervasyon anahtarı bulunamadı",
                    icon: "error",
                    draggable: true,
                });
                return;
            }

            // Checkout sayfasına yönlendirme
            navigate('/checkout', {
                state: {
                    offerKey: offerKey
                }
            });
        } catch (error) {
            console.error("Error:", error);
            Swal.fire({
                title: "Rezervasyon Hatası",
                text: error.message || "Rezervasyon sırasında bir hata oluştu",
                icon: "error",
                draggable: true,
            });
        }
    };

    const loadMoreHotels = async () => {
        if (!pagination.hasMore) return;
        setIsLoadingMore(true);
        try {
            const nextPage = pagination.currentPage + 1;
            const timestamp = new Date().getTime();
            
            // URL'den güncel filtreleme parametrelerini al
            const currentSearchParams = new URLSearchParams(window.location.search);
            const accTypes = currentSearchParams.get('accTypes');
            const chains = currentSearchParams.get('chain');
            const boards = currentSearchParams.get('boards');
            const star = currentSearchParams.get('star');
            
            const requestData = {
                geolocation: {
                    latitude: parseFloat(formParams.lat),
                    longitude: parseFloat(formParams.lng),
                    radius: 10
                },
                page: nextPage,
                perPage: 10,
                sourceMarket: formParams.nation || "DE",
                checkIn: formParams.checkIn,
                checkOut: formParams.checkOut,
                ...(boards ? { boardCodes: boards.split(',') } : {}),
                filter: {
                    ...(star ? { minCategory: parseInt(star), maxCategory: parseInt(star) } : {}),
                    ...(rates.minRate ? { minRate: rates.minRate } : {}),
                    ...(rates.maxRate ? { maxRate: rates.maxRate } : {}),
                },
                occupancies: formParams.rooms.map(room => ({
                    rooms: 1,
                    adults: room.adultCounter,
                    children: room.childCounter,
                    paxes: room.childrenAges.map(child => ({
                        type: "CH",
                        age: child.age || 0
                    }))
                })),
                ...(accTypes ? { accommodations: accTypes.split(',') } : {}),
                ...(chains ? { chains: chains.split(',') } : {}),
                ...(selectedAmenities.length > 0 ? { facilities: selectedAmenities } : {}),
                _t: timestamp,
                ...(sortOption.type !== 'default' && {
                    sortType: sortOption.type,
                    sortOrder: sortOption.column
                }),
            };

            const response = await hotelService.searchHotels(requestData);
            if (response && response.data && response.data.length > 0) {
                const rawHotels = response.data;
                
                // Otelleri ID bazında detaylarla birleştir
                const mergedHotels = await Promise.all(
                    rawHotels.map(async (hotel) => {
                        try {
                            const contentResponse = await hotelService.getHotelContent(hotel.id);
                            
                            if (contentResponse && contentResponse.code === hotel.id) {
                                const mergedData = {
                                    ...hotel,
                                    name: contentResponse.name?.content || hotel.name,
                                    description: contentResponse.description?.content || '',
                                    address: contentResponse.address?.content || hotel.address,
                                    city: contentResponse.city || {
                                        content: hotel.city
                                    },
                                    country: contentResponse.country || {
                                        code: '',
                                        isoCode: '',
                                        description: {
                                            content: hotel.country
                                        }
                                    },
                                    category: contentResponse.category?.description?.content || '',
                                    accommodationType: contentResponse.accommodationType?.typeMultiDescription?.content || '',
                                    boards: contentResponse.boards || [],
                                    facilities: contentResponse.facilities || [],
                                    image: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    thumbnail: 'https://photos.hotelbeds.com/giata/bigger/' + contentResponse.images?.[0]?.path || [],
                                    web: contentResponse.web || '',
                                    phones: contentResponse.phones || [],
                                    postalCode: contentResponse.postalCode || '',
                                    ranking: contentResponse.ranking || 0,
                                    wildcards: contentResponse.wildcards || []
                                };

                                // Fiyat dönüşümü işlemi
                                if (mergedData.rooms) {
                                    mergedData.rooms.forEach(room => {
                                        if (room.rates) {
                                            room.rates.forEach(rate => {
                                                if (rate.currency && rate.currency !== 'EUR') {
                                                    getPrice(
                                                        rate.net,
                                                        userData.token,
                                                        'EUR',
                                                        rate.taxes,
                                                        mergedData.country?.code,
                                                        rate.currency
                                                    ).then(convertedPrice => {
                                                        rate.net = convertedPrice;
                                                        rate.currency = 'EUR';
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                                
                                return mergedData;
                            } else {
                                return hotel;
                            }
                        } catch (err) {
                            console.error(`Error fetching content for hotel ${hotel.id}:`, err);
                            return hotel;
                        }
                    })
                );

                // Mevcut otellerle yeni otelleri birleştir
                setInitialHotels(prevHotels => [...prevHotels, ...mergedHotels]);
                
                // Pagination bilgilerini güncelle
                setPagination({
                    currentPage: nextPage,
                    hasMore: response.pagination?.hasMore || false,
                    totalPages: response.pagination?.totalPages || 0
                });
            }
        } catch (err) {
            console.error("Error loading more hotels:", err);
            setError(err.message);
        } finally {
            setIsLoadingMore(false);
        }
    };

    const handleResetFilters = () => {
        setSelectedStar(null);
        setSelectedBoards([]);
        setSelectedAccommodations([]);
        setSelectedChain(null);
        setSelectedAmenities([]);
        setRates({
            minRate: 0,
            maxRate: 7500
        });
        setPrices({
            min_price: 0,
            max_price: 7500
        });

        const url  = new URLSearchParams(searchParams);
        url.delete('accTypes');
        url.delete('minPrice');
        url.delete('maxPrice');
        url.delete('star');
        url.delete('boards');
        url.delete('chain');
        url.delete('amenities');
        setSearchParams(url);
        window.location.reload();
    };

    const formatCancellationDate = (dateString) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    };

    const StaticGoogleMap = ({ markers }) => {
        const center = markers.length > 0 ? markers[0] : { lat: 0, lng: 0 };
        const size = '600x300';
        const zoom = 13;
        const mapType = 'roadmap';
        const markerString = markers.map(marker => 
            `&markers=color:red%7C${marker.lat},${marker.lng}`
        ).join('');

        const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${center.lat},${center.lng}&zoom=${zoom}&size=${size}&maptype=${mapType}${markerString}&key=${config.API_KEY}`;

        return (
            <img 
                src={mapUrl} 
                alt="Google Map" 
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
        );
    };

    const getMarkers = (Hotels) => {
        if (!Hotels || Hotels.length === 0) return [];
        
        return Hotels.map(hotel => ({
            lat: parseFloat(hotel.latitude),
            lng: parseFloat(hotel.longitude)
        }));
    };

    const handleAmenityChange = (code) => {
        setSelectedAmenities(prev => {
            const newAmenities = prev.includes(code) 
                ? prev.filter(item => item !== code)
                : [...prev, code];
            
            // URL parametrelerini güncelle
            const newParams = new URLSearchParams(searchParams);
            if (newAmenities.length > 0) {
                newParams.set('amenities', newAmenities.join(','));
            } else {
                newParams.delete('amenities');
            }
            setSearchParams(newParams);
            
            return newAmenities;
        });
    };

    console.log(formParams);

    useEffect(() => {
        // Read guest selection from localStorage
        const guestSelection = localStorage.getItem('guest_selection');
        if (guestSelection) {
            const guestData = JSON.parse(guestSelection);
            console.log('Guest Selection Data:', guestData);
            
            // Log detailed information
            console.log('Total Rooms:', guestData.rooms.length);
            console.log('Total Adults:', guestData.totalAdults);
            console.log('Total Children:', guestData.totalChildren);
            
            guestData.rooms.forEach((room, index) => {
                console.log(`Room ${index + 1}:`, {
                    adults: room.adultCounter,
                    children: room.childCounter,
                    childrenAges: room.childrenAges
                });
            });
        }
    }, []);

    useEffect(() => {
        // Reset cart summary when page mounts
        setCartSummary({
            totalRooms: 0,
            roomTypes: [],
            items: {},
            quantities: {}
        });

        // Clear localStorage cart
        localStorage.removeItem('cart');

        // Update cart summary when cart changes
        const updateCartSummary = () => {
            const cart = JSON.parse(localStorage.getItem('cart')) || { data: [] };
            const guestSelection = JSON.parse(localStorage.getItem('guest_selection')) || { rooms: [] };
            
            // offerKey bazlı ürün takibi ve miktar hesaplama
            const items = {};
            const quantities = {};
            
            // Önce offerKey'leri grupla ve miktarları hesapla
            cart.data.forEach(item => {
                if (!items[item.offerKey]) {
                    items[item.offerKey] = {
                        ...item,
                        quantity: item.quantity || 1
                    };
                    quantities[item.offerKey] = item.quantity || 1;
                } else {
                    items[item.offerKey].quantity = (items[item.offerKey].quantity || 1) + (item.quantity || 1);
                    quantities[item.offerKey] = (quantities[item.offerKey] || 1) + (item.quantity || 1);
                }
            });

            // Group rooms by occupancy and room name
            const roomTypes = {};
            Object.values(items).forEach(item => {
                const key = `${item.adults}adults-${item.children}children-${item.roomName}`;
                if (!roomTypes[key]) {
                    roomTypes[key] = {
                        adults: item.adults,
                        children: item.children,
                        roomName: item.roomName,
                        count: item.quantity || 1,
                        offerKey: item.offerKey
                    };
                } else {
                    roomTypes[key].count = item.quantity || 1;
                }
            });

            // Toplam oda sayısını hesapla
            const totalRooms = Object.values(items).reduce((total, item) => total + (item.quantity || 1), 0);

            setCartSummary({
                totalRooms: totalRooms,
                roomTypes: Object.values(roomTypes),
                items: items,
                quantities: quantities
            });
        };

        // Listen for cart changes
        window.addEventListener('storage', updateCartSummary);
        return () => window.removeEventListener('storage', updateCartSummary);
    }, []);

    const handleClearCart = async () => {
        const result = await Swal.fire({
            title: 'Clear Cart',
            text: 'Are you sure you want to clear your cart?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, clear it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            localStorage.setItem('cart', JSON.stringify({ data: [] }));
            setCartSummary({ 
                totalRooms: 0, 
                roomTypes: [],
                items: {},
                quantities: {}
            });
            // Update cart count in header
            const headerCart = document.querySelector('.header-cart-count');
            if (headerCart) {
                headerCart.textContent = '0';
            }
            Swal.fire('Cleared!', 'Your cart has been cleared.', 'success');
        }
    };

    const handleMapView = () => {
        navigate(`/hotels-with-map?${searchParams.toString()}`);
        window.scrollTo(0, 0);
    };

    const handleProceedToCheckout = async () => {
        const userData = JSON.parse(localStorage.getItem('user_data'));

        if (!userData?.token) {
            Swal.fire({
                title: 'Please Login',
                text: 'You need to login to proceed to checkout',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        if (cartSummary.totalRooms === 0) {
            Swal.fire({
                title: 'Empty Cart',
                text: 'Your cart is empty',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        // Show loading alert
        Swal.fire({
            title: 'Processing...',
            text: 'Adding items to your cart',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            // Her oda tipi için işlem yap
            for (const roomType of cartSummary.roomTypes) {
                // İlk ürünü ekle ve basket_item_id'yi al
                const initialResponse = await axios.post(
                    `${config.API_BASE_URL_V1}basket/add`,
                    {
                        offer_key: roomType.offerKey,
                        type: "hotel"
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${userData.token}`
                        }
                    }
                );

                if (initialResponse.data.status !== 'success') {
                    throw new Error(`Failed to add item ${roomType.offerKey} to cart`);
                }

                // API yanıtından basket item ID'yi al
                const basketItem = initialResponse.data.data.basket.basketItems[0];
                if (!basketItem || !basketItem.id) {
                    throw new Error('Basket item ID not found in response');
                }

                const basketItemId = basketItem.id;

                // Eğer miktar 1'den fazlaysa, miktarı artır
                if (roomType.count > 1) {
                    for (let i = 1; i < roomType.count; i++) {
                        const plusResponse = await axios.post(
                            `${config.API_BASE_URL_V1}basket/plus-quantity/${basketItemId}`,
                            {},
                            {
                                headers: {
                                    'Authorization': `Bearer ${userData.token}`
                                }
                            }
                        );

                        if (plusResponse.data.status !== 'success') {
                            throw new Error(`Failed to increase quantity for item ${roomType.offerKey}`);
                        }
                    }
                }
            }
            // Clear localStorage cart after successful API calls
            localStorage.removeItem('cart');
            Swal.fire({
                toast: true,
                position: 'top-right',
                title: 'Success!',
                text: 'Your cart has been updated.',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            });
            navigate('/cart');
        } catch (error) {
            console.error('Error processing cart:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to process cart',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }
        finally {
            Swal.close();
        }
    };

    return (
        <Layout>
            <div className="breadcrumb-bar breadcrumb-bg-01 text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">
                            <h2 className="breadcrumb-title mb-2">Hotels</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center mb-0">
                                    <li className="breadcrumb-item"><a href="index.html"><i className="isax isax-home5"></i></a></li>
                                    <li className="breadcrumb-item">Hotels</li>
                                    <li className="breadcrumb-item active" aria-current="page">Hotel Lists</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="card" style={{ position: 'relative', zIndex: 1000 }}>
                        <div className="card-body">
                            <div className="banner-form" style={{ position: 'relative', zIndex: 1001 }}>
                                <SearchForm initialParams={formParams} />
                            </div>
                        </div>
                    </div>

                    <div className="row d-flex flex-column-reverse flex-xl-row">
                        <div className="col-xl-3 col-lg-3 theiaStickySidebar">


                        <div style={{ height: '150px', position: 'relative' }}>
                                <a style={{ textDecoration: 'none' }} href={`/hotels-with-map?${searchParams.toString()}`}>
                                    <GoogleMapsLoader apiKey={config.API_KEY}>
                                        <StaticGoogleMap markers={markers} />
                                    </GoogleMapsLoader>
                                    <button
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            backgroundColor: '#007bff',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '10px 20px',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        View Map
                                    </button>
                                </a>
                            </div>
                            

                            <div className="card filter-sidebar mb-lg-0 mb-4">
                                <div className="card-body p-0">
                                    <form>
                                        <div className="accordion accordion-list">

                                            {/* Reset Filters Button */}
                                            <div className="p-3 border-bottom mt-8">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary w-100"
                                                    onClick={() => handleResetFilters()}
                                                >
                                                    <i className="isax isax-refresh me-2"></i>
                                                    Reset Filters
                                                </button>
                                            </div>

                                             {/* Price Range Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-popular_p" aria-expanded="true"
                                                        aria-controls="accordion-popular" role="button">
                                                        <i className="isax isax-coin text-primary me-2"></i>Price Range
                                                    </div>
                                                </div>
                                                <div id="accordion-popular_p" className="accordion-collapse show collapse">
                                                    <div className="accordion-body d-flex flex-row ">
                                                        <div style={{ paddingTop: "20px", width: "100%", margin: "0 auto" }}>
                                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
                                                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>0 EUR</span>
                                                                <span style={{ fontWeight: 'bold', fontSize: '12px' }}>7500 EUR</span>
                                                            </div>
                                                            <RangeSlider
                                                                min={0}
                                                                max={7500}
                                                                value={[prices.min_price, prices.max_price]}
                                                                onInput={handleRangeChange}
                                                                onThumbDragEnd={handleDragEnd}
                                                                thumbsDisabled={[false, false]}
                                                                rangeSlideDisabled={false}
                                                            />
                                                            <p style={{ textAlign: 'center' }} className='mt-4 mb-4'><span style={{ fontWeight: 'bold', fontSize: '14px' }}>{prices.min_price} EUR</span> - <span style={{ fontWeight: 'bold', fontSize: '14px' }}>{prices.max_price} EUR</span></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            {/* Star Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-brands" aria-expanded="true"
                                                        aria-controls="accordion-brands" role="button">
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>Star
                                                    </div>
                                                </div>
                                                <div id="accordion-brands" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
                                                            <div className="d-flex flex-row gap-1">
                                                                {[1, 2, 3, 4, 5].map((star) => (
                                                                    <div
                                                                        key={star}
                                                                        className="d-flex flex-row gap-1"
                                                                        style={{
                                                                            border: "solid",
                                                                            borderRadius: "8px",
                                                                            margin: "2px",
                                                                            padding: "5px",
                                                                            justifyContent: "center",
                                                                            textAlign: "center",
                                                                            alignContent: "center",
                                                                            backgroundColor: selectedStar === star ? "darkgray" : "white",
                                                                            borderColor: "darkgray",
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() => handleStarClick(star)}
                                                                        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "lightgray")}
                                                                        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = selectedStar === star ? "darkgray" : "white")}
                                                                    >
                                                                        <span style={{ color: selectedStar === star ? "white" : "darkgray" }}>
                                                                            {star}
                                                                        </span>
                                                                        <FaStar style={{ margin: "auto", color: selectedStar === star ? "white" : "darkgray" }} />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Accommodation Types Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-accommodation" aria-expanded="true"
                                                        aria-controls="accordion-accommodation" role="button">
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Accommodation Types
                                                    </div>
                                                </div>
                                                <div id="accordion-accommodation" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(accommodationLess ? accommodation.slice(0, 5) : accommodation).map((item, index) => (
                                                            <div key={`accommodation-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    name="accommodation"
                                                                    type="checkbox"
                                                                    id={`accommodation-${index}`}
                                                                    value={item.code}
                                                                    checked={selectedAccommodations?.includes(item.code)}
                                                                    onChange={() => handleAccomChange(item.code)}
                                                                />
                                                                <label className="form-check-label ms-2" htmlFor={`accommodation-${index}`}>
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{item.typeDescription}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        <div className="mt-3">
                                                            <a className="btn btn-link p-0 text-primary" onClick={() => setAccommodationLess((prev) => !prev)}>
                                                                {accommodationLess ? "See More" : "See Less"}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Chains Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-chains" aria-expanded="true"
                                                        aria-controls="accordion-chains" role="button">
                                                        <FaHotel className="text-primary me-2"/>
                                                        Chains
                                                    </div>
                                                </div>
                                                <div id="accordion-chains" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(chainLess ? chains.slice(0, 5) : chains).map((item, index) => (
                                                            <div key={`chain-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    name="chain"
                                                                    type="checkbox"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    id={`chain-${index}`}
                                                                    value={item.id}
                                                                    checked={selectedChain?.includes(item.id)}
                                                                    onChange={() => handleChainChange(item.id)}
                                                                />
                                                                <label className="form-check-label ms-2" htmlFor={`chain-${index}`}>
                                                                    <span className="rating d-flex align-items-center">
                                                                        <span className="ms-2 text-capitalize">{item.name.toLocaleLowerCase()}</span>
                                                                    </span>
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {chains.length > 5 && (
                                                            <div className="mt-3">
                                                                <button 
                                                                    className="btn btn-link p-0 text-primary" 
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setChainLess((prev) => !prev);
                                                                    }}
                                                                >
                                                                    {chainLess ? "See More" : "See Less"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                             {/* Neighborhood Filter */}
                                             {dynamicNeighborhoods && dynamicNeighborhoods.length > 0 && (
                                                 <div className="accordion-item border-bottom p-3">
                                                     <div className="accordion-header">
                                                         <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                             data-bs-target="#accordion-neighborhood" aria-expanded="true"
                                                             aria-controls="accordion-neighborhood" role="button">
                                                             <i className="isax isax-location text-primary me-2"></i>
                                                             Neighborhoods
                                                         </div>
                                                     </div>
                                                     <div id="accordion-neighborhood" className="accordion-collapse show collapse">
                                                         <div className="accordion-body">
                                                             {(() => {
                                                                 const displayNeighborhoods = neighborhoodLess 
                                                                     ? dynamicNeighborhoods?.slice(0, 10) 
                                                                     : dynamicNeighborhoods;

                                                                 return displayNeighborhoods?.map((item, index) => {
                                                                     // Mahalle adını formatted_address'ten al
                                                                     const addressParts = item.formatted_address.split(',');
                                                                     const mahalleAdi = addressParts[0].trim();
                                                                     
                                                                     // İstanbul ve Fatih gibi genel alanları filtrele
                                                                     if (addressParts[0].trim() === 'Istanbul' && addressParts[1]?.trim() === 'Fatih') {
                                                                         return null;
                                                                     }

                                                                     // Kategori ikonu belirle
                                                                     let categoryIcon = "📍";
                                                                     if (item.types?.includes('neighborhood') || item.types?.includes('sublocality')) {
                                                                         categoryIcon = "🏘️";
                                                                     } else if (item.types?.includes('route') || item.types?.includes('street_address')) {
                                                                         categoryIcon = "🛣️";
                                                                     } else if (item.types?.includes('locality') || item.types?.includes('administrative_area_level_2')) {
                                                                         categoryIcon = "🏙️";
                                                                     } else if (item.types?.includes('establishment') || item.types?.includes('point_of_interest')) {
                                                                         categoryIcon = "🏢";
                                                                     } else if (item.types?.includes('postal_code')) {
                                                                         categoryIcon = "📮";
                                                                     }

                                                                     // Mahalle tipi belirleme
                                                                     let typeLabel = "";
                                                                     if (item.types?.includes('neighborhood')) {
                                                                         typeLabel = "Neighborhood";
                                                                     } else if (item.types?.includes('sublocality')) {
                                                                         typeLabel = "District";
                                                                     } else if (item.types?.includes('route')) {
                                                                         typeLabel = "Street";
                                                                     } else if (item.types?.includes('locality')) {
                                                                         typeLabel = "City Area";
                                                                     } else if (item.types?.includes('establishment')) {
                                                                         typeLabel = "Landmark";
                                                                     }

                                                                     return (
                                                                         <div key={`neighborhood-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                             <input
                                                                                 className="form-check-input ms-0 mt-0"
                                                                                 name="neighborhood"
                                                                                 type="radio"
                                                                                 style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                                 id={`neighborhood-${index}`}
                                                                                 onChange={() => handleNeighborhoodChange(item)}
                                                                             />
                                                                             <label className="form-check-label ms-2 d-flex align-items-center" htmlFor={`neighborhood-${index}`} style={{ cursor: 'pointer' }}>
                                                                                 <span className="me-2">{categoryIcon}</span>
                                                                                 <div>
                                                                                     <span className="text-capitalize fw-medium" style={{ cursor: 'pointer' }}>
                                                                                         {mahalleAdi}
                                                                                     </span>
                                                                                     <div className="d-flex align-items-center gap-2">
                                                                                         {typeLabel && (
                                                                                             <small className="badge bg-light text-dark">{typeLabel}</small>
                                                                                         )}
                                                                                         {item.distance && (
                                                                                             <small className="text-muted">
                                                                                                 {item.distance < 1 
                                                                                                     ? `${Math.round(item.distance * 1000)}m` 
                                                                                                     : `${item.distance.toFixed(1)}km`
                                                                                                 } away
                                                                                             </small>
                                                                                         )}
                                                                                     </div>
                                                                                 </div>
                                                                             </label>
                                                                         </div>
                                                                     );
                                                                 });
                                                             })()}
                                                             {dynamicNeighborhoods.length > 10 && (
                                                                 <div className="mt-3">
                                                                     <button className="btn btn-link p-0 text-primary" onClick={(e) => {
                                                                         e.preventDefault();
                                                                         setNeighborhoodLess((prev) => !prev);
                                                                     }}>
                                                                         {neighborhoodLess ? `See More (${dynamicNeighborhoods.length - 10} more)` : "See Less"}
                                                                     </button>
                                                                 </div>
                                                             )}
                                                         </div>
                                                     </div>
                                                 </div>
                                             )}

                                            {/* Popular Locations Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-popular-location" aria-expanded="true"
                                                        aria-controls="accordion-popular-location" role="button">
                                                        <i className="isax isax-location text-primary me-2"></i>
                                                        Popular Locations
                                                    </div>
                                                </div>
                                                <div id="accordion-popular-location" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(() => {
                                                            // Lokasyonları kategorilere ayır
                                                            const categorizedLocations = {
                                                                tourist: popularLocations.filter(item => 
                                                                    item.types?.includes('tourist_attraction') || 
                                                                    item.types?.includes('museum') || 
                                                                    item.types?.includes('mosque') ||
                                                                    item.types?.includes('place_of_worship')
                                                                ),
                                                                shopping: popularLocations.filter(item => 
                                                                    item.types?.includes('shopping_mall') || 
                                                                    item.types?.includes('department_store') ||
                                                                    item.types?.includes('clothing_store')
                                                                ),
                                                                dining: popularLocations.filter(item => 
                                                                    item.types?.includes('restaurant') || 
                                                                    item.types?.includes('cafe') ||
                                                                    item.types?.includes('bar')
                                                                ),
                                                                transport: popularLocations.filter(item => 
                                                                    item.types?.includes('transit_station') || 
                                                                    item.types?.includes('subway_station') ||
                                                                    item.types?.includes('bus_station')
                                                                ),
                                                                other: popularLocations.filter(item => 
                                                                    !item.types?.some(type => [
                                                                        'tourist_attraction', 'museum', 'mosque', 'place_of_worship',
                                                                        'shopping_mall', 'department_store', 'clothing_store',
                                                                        'restaurant', 'cafe', 'bar',
                                                                        'transit_station', 'subway_station', 'bus_station'
                                                                    ].includes(type))
                                                                )
                                                            };

                                                            const displayLocations = popularLocationLess 
                                                                ? popularLocations.slice(0, 8) 
                                                                : popularLocations;

                                                            return (
                                                                <>
                                                                    {displayLocations.map((item, index) => {
                                                                        // Kategori ikonu belirle
                                                                        let categoryIcon = "🏠";
                                                                        if (item.types?.includes('tourist_attraction') || item.types?.includes('museum')) {
                                                                            categoryIcon = "🏛️";
                                                                        } else if (item.types?.includes('mosque') || item.types?.includes('place_of_worship')) {
                                                                            categoryIcon = "🕌";
                                                                        } else if (item.types?.includes('shopping_mall') || item.types?.includes('department_store')) {
                                                                            categoryIcon = "🛒";
                                                                        } else if (item.types?.includes('restaurant') || item.types?.includes('cafe')) {
                                                                            categoryIcon = "🍽️";
                                                                        } else if (item.types?.includes('bar')) {
                                                                            categoryIcon = "🍺";
                                                                        } else if (item.types?.includes('transit_station') || item.types?.includes('subway_station')) {
                                                                            categoryIcon = "🚊";
                                                                        } else if (item.types?.includes('park')) {
                                                                            categoryIcon = "🌳";
                                                                        } else if (item.types?.includes('hospital')) {
                                                                            categoryIcon = "🏥";
                                                                        } else if (item.types?.includes('spa') || item.types?.includes('gym')) {
                                                                            categoryIcon = "💪";
                                                                        }

                                                                        return (
                                                                            <div key={`popular-location-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                                <input
                                                                                    className="form-check-input ms-0 mt-0"
                                                                                    name="popularLocation"
                                                                                    type="radio"
                                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                                    id={`popular-location-${index}`}
                                                                                    value={item.name}
                                                                                    checked={selectedPopularLocation?.name === item.name}
                                                                                    onChange={() => handlePopularLocationChange(item.name)}
                                                                                />
                                                                                <label className="form-check-label ms-2 d-flex align-items-center" htmlFor={`popular-location-${index}`} style={{ cursor: 'pointer' }}>
                                                                                    <span className="me-2">{categoryIcon}</span>
                                                                                    <div>
                                                                                        <span className="text-capitalize fw-medium">{item.name}</span>
                                                                                        {item.distance && (
                                                                                            <small className="text-muted d-block">
                                                                                                {item.distance < 1 
                                                                                                    ? `${Math.round(item.distance * 1000)}m` 
                                                                                                    : `${item.distance.toFixed(1)}km`
                                                                                                } away
                                                                                            </small>
                                                                                        )}
                                                                                    </div>
                                                                                </label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </>
                                                            );
                                                        })()}
                                                        {popularLocations.length > 8 && (
                                                            <div className="mt-3">
                                                                <button 
                                                                    type="button"
                                                                    className="btn btn-link p-0 text-primary" 
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setPopularLocationLess(prev => !prev);
                                                                    }}
                                                                >
                                                                    {popularLocationLess ? `See More (${popularLocations.length - 8} more)` : "See Less"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Board Types Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-boards" aria-expanded="true"
                                                        aria-controls="accordion-boards" role="button">
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Board Types
                                                    </div>
                                                </div>
                                                <div id="accordion-boards" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {boards.map((board, index) => (
                                                            <div key={`board-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    type="checkbox"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    id={`board-${index}`}
                                                                    value={board.code}
                                                                    checked={selectedBoards?.includes(board.code)}
                                                                    onChange={() => handleBoardChange(board.code)}
                                                                />
                                                                <label className="form-check-label ms-2 text-capitalize" htmlFor={`board-${index}`}>
                                                                    {board.name?.toLocaleLowerCase()}
                                                                </label>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Amenities Filter */}
                                            <div className="accordion-item border-bottom p-3">
                                                <div className="accordion-header">
                                                    <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                        data-bs-target="#accordion-amenities" aria-expanded="true"
                                                        aria-controls="accordion-amenities" role="button">
                                                        <i className="isax isax-discount-shape text-primary me-2"></i>
                                                        Facilities
                                                    </div>
                                                </div>
                                                <div id="accordion-amenities" className="accordion-collapse show collapse">
                                                    <div className="accordion-body">
                                                        {(amenitiesLess ? amenities.slice(0, 5) : amenities).map((amenity, index) => (
                                                            <div key={`amenity-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                <input
                                                                    className="form-check-input ms-0 mt-0"
                                                                    type="checkbox"
                                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                    id={`amenity-${index}`}
                                                                    value={amenity.id}
                                                                    checked={selectedAmenities?.includes(amenity.id)}
                                                                    onChange={() => handleAmenityChange(amenity.id)}
                                                                />
                                                                <label className="form-check-label ms-2 text-capitalize" htmlFor={`amenity-${index}`}>
                                                                    {amenity.name?.toLocaleLowerCase()}
                                                                </label>
                                                            </div>
                                                        ))}
                                                        {amenities.length > 5 && (
                                                            <div className="mt-3">
                                                                <button 
                                                                    type="button"
                                                                    className="btn btn-link p-0 text-primary" 
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setAmenitiesLess(prev => !prev);
                                                                    }}
                                                                >
                                                                    {amenitiesLess ? "See More" : "See Less"}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            {/* Static Neighborhoods Filter - Eğer neighborhoods var ise */}
                                            {neighborhoods && neighborhoods.length > 0 && (
                                                <div className="accordion-item border-bottom p-3">
                                                    <div className="accordion-header">
                                                        <div className="accordion-button p-0" data-bs-toggle="collapse"
                                                            data-bs-target="#accordion-static-neighborhood" aria-expanded="true"
                                                            aria-controls="accordion-static-neighborhood" role="button">
                                                            <i className="isax isax-home text-primary me-2"></i>
                                                            Nearby Areas
                                                        </div>
                                                    </div>
                                                    <div id="accordion-static-neighborhood" className="accordion-collapse show collapse">
                                                        <div className="accordion-body">
                                                            {neighborhoods.slice(0, 8).map((item, index) => {
                                                                // Kategori ikonu belirle
                                                                let categoryIcon = "🏘️";
                                                                let typeLabel = "";
                                                                
                                                                if (item.types?.includes('neighborhood')) {
                                                                    categoryIcon = "🏘️";
                                                                    typeLabel = "Neighborhood";
                                                                } else if (item.types?.includes('administrative_area_level_4')) {
                                                                    categoryIcon = "🏙️";
                                                                    typeLabel = "District";
                                                                } else if (item.types?.includes('route')) {
                                                                    categoryIcon = "🛣️";
                                                                    typeLabel = "Street";
                                                                }

                                                                const neighborhoodName = item.address_components?.find(comp => 
                                                                    comp.types.includes('administrative_area_level_4')
                                                                )?.long_name || 
                                                                item.address_components?.find(comp => 
                                                                    comp.types.includes('route')
                                                                )?.long_name || 
                                                                item.formatted_address;

                                                                return (
                                                                    <div key={`static-neighborhood-${index}`} className="form-check d-flex align-items-center mb-2 ps-0">
                                                                        <input
                                                                            className="form-check-input ms-0 mt-0"
                                                                            name="staticNeighborhood"
                                                                            type="radio"
                                                                            style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                                            id={`static-neighborhood-${index}`}
                                                                            onChange={() => {
                                                                                // Static neighborhood için ayrı bir handler yazılabilir
                                                                                console.log('Static neighborhood selected:', item);
                                                                            }}
                                                                        />
                                                                        <label className="form-check-label ms-2 d-flex align-items-center" htmlFor={`static-neighborhood-${index}`} style={{ cursor: 'pointer' }}>
                                                                            <span className="me-2">{categoryIcon}</span>
                                                                            <div>
                                                                                <span className="text-capitalize fw-medium">
                                                                                    {neighborhoodName}
                                                                                </span>
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    {typeLabel && (
                                                                                        <small className="badge bg-secondary">{typeLabel}</small>
                                                                                    )}
                                                                                    {item.distance && (
                                                                                        <small className="text-muted">
                                                                                            {item.distance < 1 
                                                                                                ? `${Math.round(item.distance * 1000)}m` 
                                                                                                : `${item.distance.toFixed(1)}km`
                                                                                            } away
                                                                                        </small>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-9 col-lg-9">
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                             <button className="btn btn-link p-0 text-primary mb-3" onClick={() => handleMapView()}>
                                Click for map view
                            </button>
                                <div className="d-flex align-items-center flex-wrap">
                                    <div className="dropdown mb-3">
                                        <a href="javascript:void(0);" className="dropdown-toggle py-2" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className="fw-medium text-gray-9">Sort By : {sortOption.column === 'default' ? 'Recommended' : sortOption.column === 'price' ? 'Price' : sortOption.column === 'name' ? 'Name' : ''}  {sortOption.type === 'asc' ? '- Ascending' : sortOption.type === 'desc' ? '- Descending' : ''}</span>
                                        </a>
                                        <div className="dropdown-menu dropdown-sm">
                                            <h6 className="fw-medium fs-16 mb-3">Sort By</h6>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="sort"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="radio"
                                                    id="sort-default"
                                                    value="default"
                                                    checked={sortOption.type === 'default'}
                                                    onChange={() => setSortOption({type: 'default', column: 'default'})}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="sort-default">Recommended</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="sort"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="radio"
                                                    id="sort-price-asc"
                                                    value="price-asc"
                                                    checked={sortOption.type === 'asc' && sortOption.column === 'price'}
                                                    onChange={() => setSortOption({type: 'asc', column: 'price'})}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="sort-price-asc">Price (Low to High)</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="sort"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="radio"
                                                    id="sort-price-desc"
                                                    value="price-desc"
                                                    checked={sortOption.type === 'desc' && sortOption.column === 'price'}
                                                    onChange={() => setSortOption({type: 'desc', column: 'price'})}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="sort-price-desc">Price (High to Low)</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="sort"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="radio"
                                                    id="sort-name-asc"
                                                    value="name-asc"
                                                    checked={sortOption.type === 'asc' && sortOption.column === 'name'}
                                                    onChange={() => setSortOption({type: 'asc', column: 'name'})}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="sort-name-asc">Name (A to Z)</label>
                                            </div>
                                            <div className="form-check d-flex align-items-center ps-0 mb-2">
                                                <input
                                                    className="form-check-input ms-0 mt-0"
                                                    name="sort"
                                                    style={{ border: 'solid gray', borderRadius: '4px', width: '17px', height: '17px', cursor: 'pointer' }}
                                                    type="radio"
                                                    id="sort-name-desc"
                                                    value="name-desc"
                                                    checked={sortOption.type === 'desc' && sortOption.column === 'name'}
                                                    onChange={() => setSortOption({type: 'desc', column: 'name'})}
                                                />
                                                <label className="form-check-label ms-2" htmlFor="sort-name-desc">Name (Z to A)</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="hotel-list">
                                <div className="row justify-content-center">
                                    <div className="col-md-12">

                                        
                                        {firstHotel && firstHotel.id && (
                                            <ListCard
                                                key={firstHotel.id}
                                                index={0}
                                                isFirstHotel={true}
                                                hotel={firstHotel}
                                                handleViewDetails={() => handleViewDetails(firstHotel)}
                                                checkIn={firstHotel.check_in}
                                                checkOut={firstHotel.check_out}
                                                setSelectedRate={() => {}}
                                                occupancies={formParams.rooms.map(room => ({
                                                    rooms: 1,
                                                    adults: room.adultCounter,
                                                    children: room.childCounter,
                                                    paxes: room.childrenAges.map(child => ({
                                                        type: "CH",
                                                        age: child.age || 0
                                                    }))
                                                }))}
                                            />
                                        )}

                                        {isLoading ? (
                                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ marginBlock: '100px' }}>
                                            <img src="/assets/gif/loading.gif" alt="Loading" style={{ width: "80px", height: "80px" }} />
                                            <p className="mt-3 mb-0">Loading Hotels...</p>
                                        </div>
                                        ) : error ? (
                                            <div className="alert alert-danger" role="alert">
                                                {error}
                                            </div>
                                        ) : initialHotels && initialHotels.length > 0 ? (
                                            <>
                                                {initialHotels?.map((hotel, index) => (
                                                    <>
                                                    {hotel.id !== firstHotel?.id && (
                                                        <ListCard 
                                                            key={hotel.id || index}
                                                            index={index}
                                                            isFirstHotel={false}
                                                            hotel={hotel}
                                                            handleViewDetails={() => handleViewDetails(hotel)}
                                                            checkIn={hotel.check_in}
                                                            checkOut={hotel.check_out}
                                                            setSelectedRate={() => {}}
                                                            occupancies={formParams.rooms.map(room => ({
                                                                rooms: 1,
                                                                adults: room.adultCounter,
                                                                children: room.childCounter,
                                                                paxes: room.childrenAges.map(child => ({
                                                                    type: "CH",
                                                                    age: child.age || 0
                                                                }))
                                                            }))}
                                                        />
                                                    )}
                                                    </>
                                                ))}
                                                
                                                {pagination.hasMore && (
                                                    <div className="text-center mt-4">
                                                        <button 
                                                            className="btn btn-primary"
                                                            onClick={() => loadMoreHotels()}
                                                            disabled={isLoadingMore}
                                                        >
                                                            {isLoadingMore ? (
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <div className="spinner-border spinner-border-sm me-2" role="status">
                                                                        <span className="visually-hidden">Loading...</span>
                                                                    </div>
                                                                    Loading...
                                                                </div>
                                                            ) : 'See More Hotels'}
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className="card mb-4">
                                            <div className="card-body text-center py-5">
                                                <div className="mb-4">
                                                    <i className="isax isax-search-normal" style={{ fontSize: "48px", color: "#6c757d" }}></i>
                                                </div>
                                                <h3 className="mb-3">No Hotels Found</h3>
                                                <p className="text-muted mb-4">
                                                    We couldn't find any hotels matching your search criteria.
                                                </p>

                                                {/* Dikkat Çekici Uyarı Metni */}
                                                <div className="alert alert-info mb-4" style={{ backgroundColor: "#e3f2fd", borderColor: "#0d6efd", color: "#0d47a1" }}>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <i className="isax isax-info-circle me-2" style={{ fontSize: "20px" }}></i>
                                                        <strong>No hotels found in this location. Please try searching in the related nearby locations below:</strong>
                                                    </div>
                                                </div>

                                                {/* Nearby Neighborhoods - Öncelikli Konum */}
                                                <div className="mb-5">
                                                    <h4 className="mb-4" style={{ color: "#0d6efd" }}>
                                                        <i className="isax isax-location me-2"></i>
                                                        Try These Nearby Locations
                                                    </h4>
                                                    <div className="d-flex flex-wrap justify-content-center gap-3">
                                                        {dynamicNeighborhoods.slice(0, 5).map((neighborhood, index) => {
                                                            // Mahalle adını al
                                                            const addressParts = neighborhood.formatted_address.split(',');
                                                            const mahalleAdi = addressParts[0].trim();
                                                            
                                                            // Kategori ikonu belirle - Tümü mavi gradient tonlarında
                                                            let categoryIcon = "📍";
                                                            let gradientColors = "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
                                                            
                                                            if (neighborhood.types?.includes('neighborhood') || neighborhood.types?.includes('sublocality')) {
                                                                categoryIcon = "🏘️";
                                                                gradientColors = "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)"; // Bright blue to dark blue
                                                            } else if (neighborhood.types?.includes('route')) {
                                                                categoryIcon = "🛣️";
                                                                gradientColors = "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)"; // Cyan to darker cyan
                                                            } else if (neighborhood.types?.includes('locality')) {
                                                                categoryIcon = "🏙️";
                                                                gradientColors = "linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)"; // Deep blue to navy
                                                            } else {
                                                                gradientColors = "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"; // Indigo gradient
                                                            }

                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className="position-relative"
                                                                    style={{ 
                                                                        background: "rgba(255, 255, 255, 0.1)",
                                                                        backdropFilter: "blur(10px)",
                                                                        borderRadius: "20px",
                                                                        padding: "3px",
                                                                        border: "1px solid rgba(255, 255, 255, 0.2)"
                                                                    }}
                                                                >
                                                                    <button
                                                                        className="btn d-flex align-items-center gap-3 w-100 h-100"
                                                                        onClick={() => {
                                                                            console.log('Neighborhood clicked for search:', neighborhood);
                                                                            handleNeighborhoodChange(neighborhood);
                                                                        }}
                                                                        title={`Search hotels in ${mahalleAdi}`}
                                                                        style={{ 
                                                                            background: gradientColors,
                                                                            border: "none",
                                                                            borderRadius: "18px",
                                                                            padding: "16px 24px",
                                                                            color: "white",
                                                                            fontWeight: "600",
                                                                            fontSize: "14px",
                                                                            textShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                                                            boxShadow: "0 8px 32px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.1)",
                                                                            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                                                                            transform: "translateY(0px)",
                                                                            position: "relative",
                                                                            overflow: "hidden"
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                            e.target.style.transform = "translateY(-4px) scale(1.02)";
                                                                            e.target.style.boxShadow = "0 20px 40px rgba(0,0,0,0.15), 0 8px 24px rgba(0,0,0,0.1)";
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.target.style.transform = "translateY(0px) scale(1)";
                                                                            e.target.style.boxShadow = "0 8px 32px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.1)";
                                                                        }}
                                                                    >
                                                                        {/* Background Shine Effect */}
                                                                        <div 
                                                                            style={{
                                                                                position: "absolute",
                                                                                top: 0,
                                                                                left: "-100%",
                                                                                width: "100%",
                                                                                height: "100%",
                                                                                background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
                                                                                transition: "left 0.6s ease"
                                                                            }}
                                                                            className="shine-effect"
                                                                        ></div>
                                                                        
                                                                        <div className="d-flex align-items-center gap-3">
                                                                            <div 
                                                                                className="d-flex align-items-center justify-content-center"
                                                                                style={{
                                                                                    width: "44px",
                                                                                    height: "44px",
                                                                                    background: "rgba(255, 255, 255, 0.2)",
                                                                                    borderRadius: "12px",
                                                                                    fontSize: "20px",
                                                                                    backdropFilter: "blur(10px)"
                                                                                }}
                                                                            >
                                                                                {categoryIcon}
                                                                            </div>
                                                                            
                                                                            <div className="d-flex flex-column align-items-start text-start">
                                                                                <span style={{ 
                                                                                    fontWeight: "700", 
                                                                                    fontSize: "15px",
                                                                                    letterSpacing: "0.3px"
                                                                                }}>
                                                                                    {mahalleAdi}
                                                                                </span>
                                                                                {neighborhood.distance && (
                                                                                    <small style={{ 
                                                                                        color: "rgba(255, 255, 255, 0.8)", 
                                                                                        fontSize: "12px",
                                                                                        fontWeight: "500"
                                                                                    }}>
                                                                                        📍 {neighborhood.distance < 1 
                                                                                            ? `${Math.round(neighborhood.distance * 1000)}m away` 
                                                                                            : `${neighborhood.distance.toFixed(1)}km away`}
                                                                                    </small>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        {/* Arrow Icon */}
                                                                        <div style={{
                                                                            marginLeft: "auto",
                                                                            opacity: "0.7",
                                                                            transition: "all 0.3s ease"
                                                                        }}>
                                                                            <i className="isax isax-arrow-right" style={{ fontSize: "16px" }}></i>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                                
                                                {/* Alternatif Öneriler */}
                                                <div className="border-top pt-4">
                                                    <h5 className="mb-4 text-muted">Or try these alternatives:</h5>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <div className="card h-100 border-0" style={{ backgroundColor: "#f8f9fa" }}>
                                                                <div className="card-body text-center py-4">
                                                                    <i className="isax isax-calendar" style={{ fontSize: "28px", color: "#6c757d", marginBottom: "12px" }}></i>
                                                                    <h6 className="card-title">Try Different Dates</h6>
                                                                    <p className="card-text small text-muted mb-0">
                                                                        Adjust check-in/out dates
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-md-4 mb-3">
                                                            <div className="card h-100 border-0" style={{ backgroundColor: "#f8f9fa" }}>
                                                                <div className="card-body text-center py-4">
                                                                    <i className="isax isax-map" style={{ fontSize: "28px", color: "#6c757d", marginBottom: "12px" }}></i>
                                                                    <h6 className="card-title">Explore Wider Area</h6>
                                                                    <p className="card-text small text-muted mb-0">
                                                                        Search in surrounding cities
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="col-md-4 mb-3">
                                                            <div className="card h-100 border-0" style={{ backgroundColor: "#f8f9fa" }}>
                                                                <div className="card-body text-center py-4">
                                                                    <i className="isax isax-user" style={{ fontSize: "28px", color: "#6c757d", marginBottom: "12px" }}></i>
                                                                    <h6 className="card-title">Change Nationality</h6>
                                                                    <p className="card-text small text-muted mb-0">
                                                                        Try different nationality
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* Fixed Cart Footer */}
            {cartSummary.totalRooms > 0 && (
                <div className="fixed-cart-footer">
                    <div className="cart-summary">
                        <FaShoppingCart className="cart-icon" />
                        <div className="summary-text">
                            <span className="total-rooms">{cartSummary.totalRooms} rooms selected</span>
                            <div className="room-types">
                                {cartSummary.roomTypes.map((type, index) => (
                                    <span key={index} className="room-type">
                                        {type.count} × {type.adults} adults {type.children > 0 ? `+ ${type.children} children` : ''} ({type.roomName})
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="cart-actions">
                        <button className="btn btn-outline-danger" onClick={handleClearCart}>
                            <FaTrash /> Clear Cart
                        </button>
                        <button className="btn btn-primary" onClick={handleProceedToCheckout}>
                            Confirm Cart
                        </button>
                    </div>
                </div>
            )}

            {/* Sticky Cart Section */}
            {cartSummary.totalRooms > 0 && (
                <div className="sticky-cart">
                    <div className="cart-summary">
                        <div className="cart-items">
                            <h5>Selected Rooms: {cartSummary.totalRooms}</h5>
                            {Object.entries(cartSummary.roomTypes).map(([key, value]) => (
                                <div key={key} className="cart-item">
                                    <span>{value.roomName} x{value.count}</span>
                                    <span>{value.adults} Adults, {value.children} Children</span>
                                </div>
                            ))}
                        </div>
                        <div className="cart-actions">
                            <button className="btn btn-danger" onClick={handleClearCart}>
                                Clear Cart
                            </button>
                            <button className="btn btn-primary" onClick={handleProceedToCheckout}>
                                Confirm Cart
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                .fixed-cart-footer {
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: white;
                    padding: 15px 20px;
                    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    z-index: 1000;
                }

                .cart-summary {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                }

                .cart-icon {
                    font-size: 24px;
                    color: #0d6efd;
                }

                .summary-text {
                    display: flex;
                    flex-direction: column;
                }

                .total-rooms {
                    font-weight: 600;
                    font-size: 16px;
                }

                .room-types {
                    display: flex;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .room-type {
                    font-size: 14px;
                    color: #666;
                    background: #f8f9fa;
                    padding: 4px 8px;
                    border-radius: 4px;
                }

                .cart-actions {
                    display: flex;
                    gap: 10px;
                }

                .btn-outline-danger {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                }

                @media (max-width: 768px) {
                    .fixed-cart-footer {
                        flex-direction: column;
                        gap: 15px;
                        padding: 10px;
                    }

                    .cart-summary {
                        width: 100%;
                    }

                    .cart-actions {
                        width: 100%;
                        justify-content: space-between;
                    }

                    .room-types {
                        flex-direction: column;
                    }
                }
            `}</style>
        </Layout>
    )
}
